import { PortalRoutes } from '@app/app-routing.module';
import {
  AncillaryTypeEnum,
  AncillaryUpsellNode,
  AvailableUpsellOptionsNode,
  PortalFeatures,
} from '@app/services/api/api.types';

export const hasTierUpsellOptions = (options: AvailableUpsellOptionsNode) =>
  options.essential || options.vip || options.executive;

export const getNextRouteAfterTiers = (upsell: AncillaryUpsellNode) => {
  const options = upsell.availableUpsellOptions;

  if (options?.gratuity || upsell.showGratuity) {
    return PortalRoutes.Gratuity;
  }

  return PortalRoutes.OverviewPayment;
};

export const resolveInitialAncillaryUpsellRoute = (
  upsell: AncillaryUpsellNode,
  isSequential: boolean,
  hasDisruption: boolean,
) => {
  const options = upsell.availableUpsellOptions;

  if (options) {
    if (hasTierUpsellOptions(options)) {
      return PortalRoutes.Tiers;
    }

    if (options.gratuity) {
      return PortalRoutes.Gratuity;
    }

    return PortalRoutes.OverviewPayment;
  }

  if (!isSequential) {
    return PortalRoutes.AncillaryBundleComponent;
  }

  if (hasDisruption) {
    return PortalRoutes.DisruptionProtection;
  }

  if (upsell.showGratuity) {
    return PortalRoutes.Gratuity;
  }

  return PortalRoutes.OverviewPayment;
};

export const hasSequentialAncillaries = (upsell: AncillaryUpsellNode) =>
  upsell.salesAgent?.portalFeatures?.includes(PortalFeatures.portal_sequentially_ancillaries) ??
  false;

export const hasDisruptionProtection = (upsell: AncillaryUpsellNode) =>
  upsell.ancillaries?.some((a) => a.type === AncillaryTypeEnum.DISRUPTION_PROTECTION) ?? false;
